
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches a tour's details from Supabase
 */
export async function fetchTourDetails(id: string) {
  if (!id) {
    throw new Error('No tour ID provided');
  }

  console.log(`Fetching tour details for ID: ${id}`);

  try {
    // Fetch tour details with translations and map data
    const { data: tourData, error: tourError } = await supabase
      .from('tours')
      .select(`
        id,
        name,
        tour_type,
        duration,
        cover_image,
        status,
        maptype,
        mapimage,
        tour_translations (
          language_code,
          title,
          description
        )
      `)
      .eq('id', id)
      .single();
      
    if (tourError) {
      console.error('Error fetching tour details:', tourError);
      throw tourError;
    }
    
    if (!tourData) {
      console.error(`No tour found with ID: ${id}`);
      throw new Error(`Tour with ID ${id} not found`);
    }
    
    console.log('Fetched tour data:', tourData);
    return tourData;
  } catch (error) {
    console.error(`Error in fetchTourDetails for ID ${id}:`, error);
    throw error;
  }
}

/**
 * Fetches exhibits associated with a tour from Supabase
 */
export async function fetchTourExhibits(tourId: string) {
  if (!tourId) {
    throw new Error('No tour ID provided');
  }

  console.log(`Fetching exhibits for tour ID: ${tourId}`);

  try {
    // Fetch tour exhibits with exhibit details and media
    const { data: tourExhibitsData, error: exhibitsError } = await supabase
      .from('tour_exhibits')
      .select(`
        id,
        sequence_order,
        exhibit:exhibits (
          id,
          number_code,
          status,
          exhibit_translations (
            language_code,
            title
          ),
          media:exhibit_media (
            type,
            media_file:media_id (
              url,
              mime_type,
              metadata
            )
          )
        )
      `)
      .eq('tour_id', tourId)
      .order('sequence_order');
      
    if (exhibitsError) {
      console.error('Error fetching tour exhibits:', exhibitsError);
      throw exhibitsError;
    }
    
    // Log if no exhibits were found
    if (!tourExhibitsData || tourExhibitsData.length === 0) {
      console.log(`No exhibits found for tour ID: ${tourId}`);
      return [];
    }
    
    // Filter only published exhibits
    const publishedExhibits = tourExhibitsData.filter(item => 
      item && 
      item.exhibit && 
      item.exhibit.status === 'published'
    );
    
    console.log(`Fetched ${tourExhibitsData.length} tour exhibits, ${publishedExhibits.length} are published`);
    console.log('Sample exhibit data:', publishedExhibits[0]);
    return publishedExhibits;
  } catch (error) {
    console.error(`Error in fetchTourExhibits for tour ID ${tourId}:`, error);
    throw error;
  }
}
